export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('playlist', {
    label: 'Playlist',
    category: 'Media',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      type: 'playlist',
      style: {
        width: '30%',
        height: '30%'
      }
    },
    attributes: {
      class: 'fa fa-indent' //icon in the panel
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/playlist/blocks.js